import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { companiesSelector } from '../../store/selectors';
import { setCompanies } from '../../store/actions';
import useCompanies from '../../../../queries/useCompanies';
import useFilterChange from '../../hooks/useFilterChange';
import { filterDelay } from '../../constants/common';

const SelectCompanies = ({ className }) => {
  const selectedCompanies = useSelector(companiesSelector);
  const [value, setValue] = useState(selectedCompanies);

  const { data: companies, isFetching: isCompaniesFetching } = useCompanies({
    staleTime: Infinity,
  });

  const change = useFilterChange({ action: setCompanies, delay: filterDelay });

  const handleChange = (values) => {
    setValue(values);
    change(values);
  };

  useEffect(() => {
    setValue(selectedCompanies);
  }, [selectedCompanies]);

  return (
    <Select
      className={className}
      loading={isCompaniesFetching}
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      placeholder="Управляющая компания"
      value={companies?.length ? value : []}
      optionFilterProp="searchtext"
      onChange={handleChange}
    >
      {companies?.map((company) => (
        <Select.Option
          key={company.id}
          value={company.id}
          searchtext={company.name}
        >
          {company.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectCompanies;
